import React from "react";
import styles from "../../assets/styles/Charge/Charge.module.scss";
import {
  MimaButton,
  MimaDropdown,
  MimaInput,
  MimaText,
  Modal,
} from "../../components";
import { Field, FieldArray, Formik } from "formik";
import countries2 from "../../utils/countries2.json";

const FieldInput = ({ field, ...props }) => {
  return <MimaInput {...field} {...props} />;
};

const CreatePaymentMethod = ({
  closeModal,
  onSubmit,
  validationSchema,
  loading,
  currencyCodes,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={4}>
        Create Payment Method
      </MimaText>
      <Formik
        initialValues={{
          methods: [
            {
              name: "",
              requiredFields: [""],
            },
          ],
          countryCode: "",
          currencyCode: "",
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <>
            <MimaDropdown
              labelTitle="Currency"
              placeholder="Select Currency"
              name="currencyCode"
              data={currencyCodes}
              value={values.currencyCode}
              id="currencyCode"
              onChange={(data) => {
                setFieldValue("currencyCode", data.key);
              }}
              error={errors.currencyCode}
              touched={touched.currencyCode}
            />
            <MimaDropdown
              labelTitle="Country"
              name="countryCode"
              value={values.countryCode}
              placeholder="Select Country"
              id="countryCode"
              currentValue={values.countryCode}
              onChange={(data) => {
                setFieldValue("countryCode", data.key);
              }}
              data={countries2.map((value) => {
                return {
                  key: value.countryCode,
                  value: value.countryName,
                };
              })}
              touched={touched.countryCode}
              error={errors.countryCode}
            />

            <>
              <MimaText variant="BodyBold" align="center">
                Payment Method Info
              </MimaText>
              <FieldArray name="methods">
                {({ push, remove }) => (
                  <div>
                    {values.methods.map((method, methodIndex) => (
                      <div
                        key={`method-${methodIndex}`}
                        className={styles.methodSection}
                      >
                        <MimaText variant="smallBold" mb={2}>
                          Method {methodIndex + 1}
                        </MimaText>

                        <MimaInput
                          labelTitle="Method Name"
                          name={`methods.${methodIndex}.name`}
                          placeholder="Enter name"
                          value={method.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors?.methods?.[methodIndex]?.name}
                          touched={touched?.methods?.[methodIndex]?.name}
                        />

                        <MimaText variant="small" align="center" mb={2}>
                          Required Fields
                        </MimaText>

                        <FieldArray
                          name={`methods.${methodIndex}.requiredFields`}
                        >
                          {({ push: pushField, remove: removeField }) => (
                            <React.Fragment>
                              {method.requiredFields.map((_, fieldIndex) => (
                                <React.Fragment key={`field-${fieldIndex}`}>
                                  <div>
                                    <Field
                                      name={`methods.${methodIndex}.requiredFields.${fieldIndex}`}
                                      component={FieldInput}
                                      type="text"
                                      placeholder="Enter Field"
                                      labelTitle="Label"
                                      error={
                                        errors?.methods?.[methodIndex]
                                          ?.requiredFields?.[fieldIndex]
                                      }
                                    />
                                  </div>
                                  {fieldIndex !== 0 ? (
                                    <MimaButton
                                      onClick={() => removeField(fieldIndex)}
                                      buttonColor="var(--color-error)"
                                      title="Remove"
                                      height="4"
                                    />
                                  ) : null}
                                </React.Fragment>
                              ))}
                              <MimaButton
                                title="Add Another Field"
                                variant="text"
                                type="button"
                                mt={1}
                                mb={3}
                                onClick={() => pushField("")}
                              />
                            </React.Fragment>
                          )}
                        </FieldArray>

                        {methodIndex !== 0 && (
                          <MimaButton
                            onClick={() => remove(methodIndex)}
                            buttonColor="var(--color-error)"
                            title="Remove Method"
                            height="4"
                          />
                        )}

                        <div className={styles.divider} />
                      </div>
                    ))}
                    <MimaButton
                      title="Add Another Method"
                      variant="outlined"
                      type="button"
                      mt={1}
                      mb={3}
                      onClick={() =>
                        push({
                          name: "",
                          requiredFields: [""],
                        })
                      }
                    />
                  </div>
                )}
              </FieldArray>
            </>
            <MimaButton
              title="Save"
              width={38}
              buttonColor="var(--color-dark-4)"
              onClick={handleSubmit}
              loading={loading}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};
export default CreatePaymentMethod;
